export default "__VITE_ASSET__CFkXCX04__"